/**
 * Extract structured US address components from a Mapbox Geocoding API feature.
 *
 * @param {Object} feature Mapbox geocoding feature
 * @returns {Object|null} { line1, city, state, postalCode, country }
 */
export const extractAddressComponentsFromMapboxFeature = feature => {
  if (!feature || feature.predictionPlace) {
    return null;
  }

  const context = feature.context || [];
  const getContext = prefix => context.find(c => c.id && c.id.startsWith(prefix));

  const postcode = getContext('postcode')?.text;
  const place = getContext('place')?.text || getContext('locality')?.text;
  const region = getContext('region');
  const stateFromShort = region?.short_code?.replace(/^US-/i, '');
  const state = stateFromShort || region?.text;
  const countryEntry = getContext('country');
  const country = countryEntry?.short_code?.toUpperCase() || 'US';

  const line1 =
    feature.address && feature.text
      ? `${feature.address} ${feature.text}`
      : feature.place_name?.split(',')[0]?.trim() || '';

  if (!line1 || !place || !state || !postcode) {
    return null;
  }

  return {
    line1,
    city: place,
    state,
    postalCode: postcode,
    country,
  };
};
